const TEMPLATES = [
  {
    id: 'printful',
    name: 'Printful',
    products: [
      { id: 'printful-tshirt', name: 'T-Shirt', width: 4500, height: 5400 },
      { id: 'printful-hoodie', name: 'Hoodie', width: 4500, height: 5400 },
      { id: 'printful-poster-24x36', name: 'Poster 24×36"', width: 7200, height: 10800 },
      { id: 'printful-poster-18x24', name: 'Poster 18×24"', width: 5400, height: 7200 },
      { id: 'printful-canvas', name: 'Canvas', width: 6000, height: 7500 },
      { id: 'printful-phonecase', name: 'Phone Case', width: 3000, height: 4500 },
      { id: 'printful-mug', name: 'Mug', width: 3000, height: 3000 },
      { id: 'printful-totebag', name: 'Tote Bag', width: 4500, height: 5400 },
    ],
  },
  {
    id: 'printify',
    name: 'Printify',
    products: [
      { id: 'printify-tshirt', name: 'T-Shirt', width: 4500, height: 5400 },
      { id: 'printify-sweatshirt', name: 'Sweatshirt', width: 4500, height: 5400 },
      { id: 'printify-poster', name: 'Poster', width: 7200, height: 10800 },
      { id: 'printify-sticker', name: 'Sticker', width: 3000, height: 4500 },
      { id: 'printify-hat', name: 'Hat', width: 4000, height: 4000 },
    ],
  },
  {
    id: 'redbubble',
    name: 'Redbubble',
    products: [
      { id: 'rb-tshirt', name: 'T-Shirt', width: 4800, height: 6000 },
      { id: 'rb-sticker', name: 'Sticker', width: 2550, height: 3300 },
      { id: 'rb-phonecase', name: 'Phone Case', width: 3000, height: 4500 },
      { id: 'rb-artprint', name: 'Art Print', width: 6000, height: 7200 },
      { id: 'rb-notebook', name: 'Spiral Notebook', width: 3300, height: 2550 },
      { id: 'rb-pillow', name: 'Throw Pillow', width: 4500, height: 4500 },
    ],
  },
  {
    id: 'amazon-merch',
    name: 'Amazon Merch',
    products: [
      { id: 'amz-tshirt', name: 'Standard T-Shirt', width: 4500, height: 5400 },
      { id: 'amz-premium-tshirt', name: 'Premium T-Shirt', width: 4500, height: 5400 },
      { id: 'amz-hoodie', name: 'Hoodie', width: 4500, height: 5400 },
      { id: 'amz-popsocket', name: 'PopSocket', width: 2400, height: 3600 },
    ],
  },
];

export function getPlatforms() {
  return TEMPLATES;
}

export function getPlatform(id) {
  return TEMPLATES.find(p => p.id === id) || null;
}

export function getProduct(platformId, productId) {
  const platform = getPlatform(platformId);
  if (!platform) return null;
  return platform.products.find(p => p.id === productId) || null;
}

export default TEMPLATES;
